import React from 'react';
import 'mdui/mdui.css';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import * as Sentry from '@sentry/browser';
import vars from './config/vars.config';
import AppRoutes from './routes';

Sentry.init({
  enabled: vars.sentryEnabled,
  dsn: vars.sentryDsn,
  integrations: [Sentry.browserTracingIntegration()],
  environment: vars.sentryEnvironment,
  release: '1.0',
  tracesSampleRate: 1.0
});

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
